var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('tabs',{staticClass:"border-bottom",attrs:{"tabs":_vm.rutas}}),_c('div',{staticClass:"custom-scroll overflow-auto",staticStyle:{"height":"calc(100vh - 134px)"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }